// Redux.
import { connect } from 'react-redux';


import RequestAppInvite from '../components/RequestAppInvite';

const DownloadAndroid = ({ }) => {
    return (
        <div>
            <div className='container'>
                <RequestAppInvite />
            </div>
        </div>
    );
}

const mapStateToProps = (state) => ({

})

const mapActionsToProps = {

}

export default connect(mapStateToProps, mapActionsToProps)(DownloadAndroid);